import { defineStore } from 'pinia'
import { CampaignListRecord } from '@letsdial/api/src/lib/types/CampaignListRecord'
import { CampaignListRecordContactDetails } from '@letsdial/api/src/lib/types/CampaignListRecordContactDetails'
import useLetsDialAPI from '../services/letsDialAPI/useLetsDialAPI'
import { PopRecordEvent } from '@letsdial/socket'
import { useCallStore } from './callStore'
import {
  Campaign,
  CampaignList,
  Callback,
} from '@letsdial/api/src'

export const useRecordStore = defineStore({
  // unique id of the store across your application
  id: 'record',
  state: () =>
    ({
      pop: undefined,
      record: undefined,
      contactDetails: [],
      campaignList: undefined,
      campaign: undefined,
      callBack: undefined,
    }) as {
      pop?: PopRecordEvent
      record?: CampaignListRecord
      contactDetails: Array<CampaignListRecordContactDetails>
      campaignList?: CampaignList
      campaign?: Campaign
      callBack?: Callback
    },
  getters: {
    onRecord(state) {
      return !!state.record
    },
  },
  actions: {
    setPop(pop?: PopRecordEvent) {
      this.pop = pop
      if (pop) {
        this.getRecord(pop.recordID)
        if (pop.campaignID) {
          const callStore = useCallStore()
          callStore.getAndSetDispositions(pop.campaignID)
        }
      }
    },
    async getRecord(id: number) {
      const api = useLetsDialAPI()
      const recordRequest = await api.campaignListRecords.get(id, {
        include: 'contactDetails',
      })
      if (recordRequest.data?.relationships.campaignList.data?.id) {
        await this.getCampaignList(
          recordRequest.data?.relationships.campaignList.data?.id,
        )
      }
      this.setRecord(recordRequest.data ?? undefined)
      this.setContactDetails(
        (recordRequest.included as Array<CampaignListRecordContactDetails>) ??
          [],
      )
    },
    async getCampaignList(id: number) {
      const api = useLetsDialAPI()
      const request = await api.campaignLists.get(id, {
        include: 'campaign',
      })
      this.campaignList = request.data ?? undefined
      if (request.included?.length === 1) {
        this.campaign = request.included[0] as Campaign
      }
    },
    setCallback(callBack?: Callback) {
      this.callBack = callBack
    },
    setRecord(record?: CampaignListRecord) {
      if (!record) {
        // @ts-expect-error: Intentional ignore
        this.setContactDetails([])
        this.campaignList = undefined
        this.campaign = undefined
        this.callBack = undefined
      }
      this.record = record
    },
    setContactDetails(contactDetails: Array<CampaignListRecordContactDetails>) {
      this.contactDetails = contactDetails
    },
  },
})
